import React from 'react';

const base = {
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
};

export const AwardIcon = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="8" r="6" />
    <polyline points="8.2 13.6 7 22 12 19 17 22 15.8 13.6" />
  </svg>
);

export const FileCheckIcon = (props) => (
  <svg {...base} {...props}>
    <rect x="5" y="3" width="14" height="18" rx="2" />
    <line x1="8" y1="7.5" x2="16" y2="7.5" />
    <polyline points="8 13.5 10.5 16 16 10.5" />
  </svg>
);

export const ShieldCheckIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M12 21s8-4 8-10V5l-8-3-8 3v6c0 6 8 10 8 10Z" />
    <polyline points="9 12 11.3 14.3 15.3 9.3" />
  </svg>
);

export const StarIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 21 12 17.77 5.82 21 7 14.14 2 9.27l6.91-1.01L12 2z" />
  </svg>
);

export const LockIcon = (props) => (
  <svg {...base} {...props}>
    <rect x="5" y="11" width="14" height="10" rx="2" />
    <path d="M8 11V7a4 4 0 0 1 8 0v4" />
  </svg>
);

export const BanknoteIcon = (props) => (
  <svg {...base} {...props}>
    <rect x="2" y="6" width="20" height="12" rx="2" />
    <circle cx="12" cy="12" r="3" />
    <line x1="6" y1="12" x2="6.01" y2="12" />
    <line x1="18" y1="12" x2="18.01" y2="12" />
  </svg>
);

export const AlertCircleIcon = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="12" r="9" />
    <line x1="12" y1="7.5" x2="12" y2="13" />
    <circle cx="12" cy="16.3" r="0.9" fill="currentColor" stroke="none" />
  </svg>
);

export const TrendingUpIcon = (props) => (
  <svg {...base} {...props}>
    <polyline points="3 17 9.5 10.5 13.5 14.5 21 7" />
    <polyline points="15 7 21 7 21 13" />
  </svg>
);

export const BoltIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M13 2 3 14h9l-1 8 10-12h-9l1-8Z" />
  </svg>
);

export const CpuIcon = (props) => (
  <svg {...base} {...props}>
    <rect x="6" y="6" width="12" height="12" rx="2" />
    <rect x="9.5" y="9.5" width="5" height="5" />
    <line x1="9.5" y1="1.5" x2="9.5" y2="4" />
    <line x1="14.5" y1="1.5" x2="14.5" y2="4" />
    <line x1="9.5" y1="20" x2="9.5" y2="22.5" />
    <line x1="14.5" y1="20" x2="14.5" y2="22.5" />
    <line x1="20" y1="9.5" x2="22.5" y2="9.5" />
    <line x1="20" y1="14.5" x2="22.5" y2="14.5" />
    <line x1="1.5" y1="9.5" x2="4" y2="9.5" />
    <line x1="1.5" y1="14.5" x2="4" y2="14.5" />
  </svg>
);

export const MonitorIcon = (props) => (
  <svg {...base} {...props}>
    <rect x="2" y="3" width="20" height="14" rx="2" />
    <line x1="8" y1="21" x2="16" y2="21" />
    <line x1="12" y1="17" x2="12" y2="21" />
  </svg>
);

export const SendIcon = (props) => (
  <svg {...base} {...props}>
    <line x1="22" y1="2" x2="11" y2="13" />
    <polygon points="22 2 15 22 11 13 2 9 22 2" />
  </svg>
);

export const CheckCircleIcon = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="12" r="9" />
    <polyline points="8.3 12.5 10.8 15 15.7 9.3" />
  </svg>
);

export const XCircleIcon = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="12" r="9" />
    <line x1="9.2" y1="9.2" x2="14.8" y2="14.8" />
    <line x1="14.8" y1="9.2" x2="9.2" y2="14.8" />
  </svg>
);

export const MinusCircleIcon = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="12" r="9" />
    <line x1="8" y1="12" x2="16" y2="12" />
  </svg>
);
